import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ultimoUso',
  standalone: true
})
export class UltimoUsoPipe implements PipeTransform {

  transform(value: string): number {
    var fechaInicio = new Date(value).getTime();
    var fechaActual = new Date().getTime();
    var diff = fechaActual - fechaInicio;
    diff = Math.round(diff/ (1000*60*60*24))
    if (diff<=7){
      diff = 7;
    }else if (diff<=30){
      diff = 30;
    }else{
      diff = 31;
    }
    return diff;
  }

}
